<template>
  <CategoryFiltersMobile
    v-if="shouldRender"
    v-once
    :tier="0"
    :entity-type="entityType"
    :category-filter="categoryFilter"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import categoryHelper from '../mixins/categoryHelper'
import CategoryFiltersMobile from './CategoryFiltersMobile.vue'

export default {
  name: 'CategoryFiltersContainerMobile',

  components: {
    CategoryFiltersMobile
  },

  mixins: [categoryHelper],

  props: {
    entityType: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      findCategoryFiltersby: 'listingPageFilters/findCategoryFiltersby'
    }),

    shouldRender() {
      if (this.entityType !== 'category') return true

      const isL3Category =
        this.$route.params.topCategory &&
        this.$route.params.category &&
        this.$route.params.subCategory

      return !isL3Category && this.categoryFilter.children.length
    },

    categoryFilter() {
      let categories
      let children
      let filterFn
      let title
      const isFilterModal = true

      if (this.entityType === 'category') {
        // This is to deep copy the data from state
        const categoriesCopy = JSON.parse(JSON.stringify(this.categories))
        categories = this._transformCategories(categoriesCopy)
        filterFn = this._filterBySlugUrl(this.categorySlugUrl)

        const categoryTree = this.categoryTree(
          categories,
          this.categorySlugUrl,
          filterFn,
          isFilterModal
        )

        title = categoryTree[0].label
        children = categoryTree[0].children
      } else {
        // This is to deep copy the data from state
        categories = JSON.parse(JSON.stringify(this.categoryFilters))
        filterFn = this._filterByParentId(undefined)

        children = this.categoryTree(
          categories,
          this.categorySlugUrl,
          filterFn,
          isFilterModal
        )
      }

      return {
        id: 0,
        label: this.$t('products.filters.categories'),
        title,
        children
      }
    }
  },

  created() {
    if (this.entityType !== 'category') {
      this.$store.commit(
        'listingPageFilters/setListingPageCurrentCategoryFilter',
        this.findCategoryFiltersby('slugUrl', this.categorySlugUrl)
      )
    }
  }
}
</script>
